import { Directive, ElementRef, Input, OnDestroy, inject } from '@angular/core';
import {
  selectorCoreNavigateToResourceStack,
  selectorCoreNavigateToResourceStackPreviousItemData
} from '@bepatient/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[bpDisplayIfStackOfResources]',
  standalone: false
})
export class DisplayIfStackOfResourcesDirective implements OnDestroy {
  private el = inject(ElementRef);
  private store = inject<Store<any>>(Store);

  private subscription: Subscription;
  private fromUrl: string;
  private previousStack: boolean;

  @Input('bpDisplayIfStackOfResources') set visibility(v: boolean) {
    // Note: For now this is only developed for Factsheet.
    this.subscription = this.store
      .pipe(select(selectorCoreNavigateToResourceStack))
      .subscribe(
        stack =>
          (this.fromUrl =
            stack && stack.length > 0 && stack[stack.length - 1]
              ? stack[stack.length - 1].fromUrl
              : null)
      );

    this.subscription = this.store
      .pipe(select(selectorCoreNavigateToResourceStackPreviousItemData))
      .subscribe(data => (this.previousStack = data ? true : false));

    if (v && this.fromUrl && this.fromUrl === '/timeline') {
      this.el.nativeElement.style.visibility = v ? 'hidden' : 'inherit';
    }
    if (v && this.fromUrl !== '/timeline' && this.previousStack) {
      this.el.nativeElement.style.visibility = v ? 'inherit' : 'hidden';
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
